if (!customElements.get('custom-drawer')) {
  class CustomDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('.js-drawer-overlay').addEventListener('click', this.close.bind(this));
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('custom-drawer', CustomDrawer);
}

if (!customElements.get('custom-drawer-button')) {
  class CustomDrawerButton extends HTMLElement {
    constructor() {
      super();

      this.drawerId = this.getAttribute('data-drawer-id');

      if (!this.drawerId) {
        return;
      }

      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
      const $drawer = document.querySelector(`#${this.drawerId}`);

      $drawer.open();
    }
  }

  customElements.define('custom-drawer-button', CustomDrawerButton);
}
